var outputAlphaPS = `
gl_FragColor.a = dAlpha;
`;

export { outputAlphaPS as default };
